var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/Imag/banner16.png"),"alt":"banner"}}),_c('Aboutme'),_c('Projects'),_c('Experience'),_c('Education'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }